// extracted by mini-css-extract-plugin
export default {"l":"_953d918da9"};